import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoutes from "../../core/routes/PrivateRoutes";
import { ListarCupons } from "../pages/ListarCupons";
import { ListarProgramasFidelidade } from "../pages/ListarProgramasFidelidade";
import { ListarCampanhas } from "../pages/ListarCampanhas";
import { Layout } from "../../core/components/Layout";

interface IPromocoesRoutesProps {
    autenticado: boolean;
}

export const PromocoesRoutes = ({ autenticado }: IPromocoesRoutesProps) => {
    return (
        <Routes>
            <Route element={
                <Layout titulo="Promoções">
                    <PrivateRoutes
                        autenticado={autenticado}
                    />
                </Layout>
            }>
                <Route path="/campanhas" element={<ListarCampanhas />} />
                <Route path="/cupons" element={<ListarCupons />} />
                <Route path="/programas-fidelidade" element={<ListarProgramasFidelidade />} />
                <Route path="*" element={<Navigate to="/pagina-nao-encontrada" />} />
            </Route>
        </Routes>
    );
}
